import React, { Component } from 'react';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Link } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import Api from '../../../libraries/api';
import { ToastContainer } from 'react-toastify';
import TablePagination from '@material-ui/core/TablePagination';
import TablePaginationActions from '../../presentational/table-pagination-actions';
import moment from 'moment';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';

require('dotenv').config();

const API_PATH = '/report/projects/upcoming-surveys';

class UpcomingSurveys extends Component {
    _isMounted = false;

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            orderBy: '',
            sortedBy: '',
            searchBy: '',
            rows: [],
            total: 0,
            perPage: 15,
            currentPage: 1,
            currentPageTable: 0,
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        document.title = 'Abadi - Upcoming Surveys';
        this.__fetchData();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    formatCaseName(row) {
        const caseNumber = row?.case_number ?? row?.case_name ?? '';
        const vessel = row?.vessel_name ?? '';

        if (caseNumber && vessel) {
            return `${caseNumber} - ${vessel}`;
        }

        return caseNumber || vessel || row?.case_name || '';
    }

    formatDate(value) {
        if (!value) return '';
        const m = moment(value);
        return m.isValid() ? m.format('DD MMM YYYY') : '';
    }

    formatDateTime(value) {
        if (!value) return '';
        const m = moment(value);
        return m.isValid() ? m.format('DD MMM YYYY HH:mm') : '';
    }

    normalizeRows(data) {
        if (!Array.isArray(data)) return [];

        return data.map((row) => {
            const projectId = row?.project_id ?? row?.id;

            return {
                ...row,
                projectId,
                caseType: row?.case_type ?? '',
                caseName: this.formatCaseName(row),
                appointmentDate: row?.appointment_date ?? null,
                location: row?.location ?? '',
                surveyStart: row?.survey_start_date ?? null,
            };
        });
    }

    __fetchData = () => {
        this._isMounted = true;
        this.setState({ loading: true });

        const page = this.state.currentPageTable + 1;
        const sort = this.state.orderBy
            ? `&orderBy=${this.state.orderBy}&sortedBy=${this.state.sortedBy}`
            : '';
        const search = this.state.searchBy ? `&search=${encodeURIComponent(this.state.searchBy)}` : '';

        const route = `${API_PATH}?page=${page}&limit=${this.state.perPage}${sort}${search}`;

        Api.get(route)
            .then((resp) => {
                if (!this._isMounted || !resp?.data) return;

                const pagination = resp?.meta?.pagination ?? resp?.pagination ?? {};
                const currentPage = pagination.current_page ?? page;
                this.setState({
                    rows: this.normalizeRows(resp.data),
                    perPage: pagination.per_page ?? this.state.perPage,
                    currentPage,
                    currentPageTable: currentPage - 1,
                    total: pagination.total ?? resp.data.length,
                    loading: false,
                });
            })
            .catch(() => {
                if (this._isMounted) {
                    this.setState({ loading: false, rows: [], total: 0 });
                }
            });
    };

    handleSearch = () => {
        this.setState({ currentPage: 1, currentPageTable: 0 }, () => {
            this.__fetchData();
        });
    };

    handleKeyDown = (e) => {
        if (e.key === 'Enter') this.handleSearch();
    };

    handleSort = (val) => {
        let sortedBy = this.state.sortedBy;

        if (val !== this.state.orderBy) {
            sortedBy = 'asc';
        } else {
            sortedBy = sortedBy === 'asc' ? 'desc' : 'asc';
        }

        this.setState(
            {
                orderBy: val,
                sortedBy,
                loading: true,
            },
            () => {
                this.__fetchData();
            }
        );
    };

    handleChange(e, prop) {
        this.setState({ [prop]: e.target.value });
    }

    handleChangePage = (event, newPage) => {
        this.setState(
            {
                rows: [],
                currentPage: newPage,
                currentPageTable: newPage,
                loading: true,
            },
            () => {
                this.__fetchData();
            }
        );
    };

    handleChangeRowsPerPage = (event) => {
        this.setState(
            {
                perPage: parseInt(event.target.value, 10),
                currentPage: 1,
                currentPageTable: 0,
                loading: true,
            },
            () => {
                this.__fetchData();
            }
        );
    };

    renderSortIcon(field) {
        if (this.state.orderBy !== field) {
            return (
                <span className="icon-sort">
                    <i className="fas fa-long-arrow-alt-up"> </i>
                    <i className="fas fa-long-arrow-alt-down"> </i>
                </span>
            );
        }

        return (
            <span className="icon-sort">
                <i
                    className={
                        this.state.sortedBy === 'asc'
                            ? 'fas fa-long-arrow-alt-up active'
                            : 'fas fa-long-arrow-alt-up'
                    }
                >
                    {' '}
                </i>
                <i
                    className={
                        this.state.sortedBy === 'asc'
                            ? 'fas fa-long-arrow-alt-down'
                            : 'fas fa-long-arrow-alt-down active'
                    }
                >
                    {' '}
                </i>
            </span>
        );
    }

    render() {
        return (
            <div className="row main-content">
                <div className="col-12 px-lg-5">
                    <h1 className="page-title">Upcoming Surveys</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Upcoming Surveys
                            </li>
                        </ol>
                    </nav>
                </div>

                <div className="col-12 mt-3 px-lg-5">
                    <div className="table-wrapper">
                        <div className="row align-items-center mb-md-3">
                            <div className="col-md-8">
                                <TextField
                                    id="upcoming-surveys-search"
                                    variant="outlined"
                                    className="search-field"
                                    onChange={(e) => this.handleChange(e, 'searchBy')}
                                    onKeyDown={this.handleKeyDown}
                                    onBlur={this.handleSearch}
                                    placeholder="Search here"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="start">
                                                <IconButton aria-label="Search" onClick={this.handleSearch}>
                                                    <i className="fas fa-search"> </i>
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </div>
                        </div>

                        <TableContainer>
                            <Table className="table-list" size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Action</TableCell>
                                        <TableCell className="clickable" onClick={() => this.handleSort('case_type')}>
                                            Case Type
                                            {this.renderSortIcon('case_type')}
                                        </TableCell>
                                        <TableCell className="clickable" onClick={() => this.handleSort('case_name')}>
                                            Case Name
                                            {this.renderSortIcon('case_name')}
                                        </TableCell>
                                        <TableCell
                                            className="clickable"
                                            onClick={() => this.handleSort('appointment_date')}
                                        >
                                            Appointment Date
                                            {this.renderSortIcon('appointment_date')}
                                        </TableCell>
                                        <TableCell className="clickable" onClick={() => this.handleSort('location')}>
                                            Location
                                            {this.renderSortIcon('location')}
                                        </TableCell>
                                        <TableCell
                                            className="clickable"
                                            onClick={() => this.handleSort('survey_start_date')}
                                        >
                                            Survey Start
                                            {this.renderSortIcon('survey_start_date')}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.loading ? (
                                        <TableRow>
                                            <TableCell colSpan={6} align="center" className="py-5">
                                                <CircularProgress color="primary" />
                                            </TableCell>
                                        </TableRow>
                                    ) : this.state.rows.length === 0 ? (
                                        <TableRow style={{ height: 33 * this.state.perPage }}>
                                            <TableCell colSpan={6} style={{ textAlign: 'center' }}>
                                                No upcoming survey data
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        this.state.rows.map((row) => (
                                            <TableRow key={row.projectId}>
                                                <TableCell>
                                                    <div className="d-flex justify-content-center">
                                                        <Link
                                                            to={`/projects/detail/${row.projectId}`}
                                                            className="btn-icon mr-2"
                                                        >
                                                            <i className="fas fa-eye"> </i>
                                                        </Link>
                                                        <Link
                                                            to={`/projects/edit/${row.projectId}`}
                                                            className="btn-icon mr-2"
                                                        >
                                                            <i className="fas fa-edit"> </i>
                                                        </Link>
                                                    </div>
                                                </TableCell>
                                                <TableCell>{row.caseType}</TableCell>
                                                <TableCell>
                                                    <Link to={`/projects/detail/${row.projectId}`} target="_blank">
                                                        {row.caseName}
                                                    </Link>
                                                </TableCell>
                                                <TableCell>{this.formatDate(row.appointmentDate)}</TableCell>
                                                <TableCell>{row.location}</TableCell>
                                                <TableCell>{this.formatDateTime(row.surveyStart)}</TableCell>
                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>

                    <TablePagination
                        rowsPerPageOptions={[15, 25, 50, 100]}
                        component="div"
                        count={this.state.total}
                        rowsPerPage={this.state.perPage}
                        page={this.state.currentPageTable}
                        backIconButtonProps={{
                            'aria-label': 'previous page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'next page',
                        }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                    />
                </div>

                <ToastContainer autoClose={3000} />
            </div>
        );
    }
}

export default UpcomingSurveys;
